import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { Modal, Button } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import * as jsonpatch from "fast-json-patch";
import * as endpoints from "constants/endpoints";
import { sendRequest } from "../../helpers/fetch_helper.js";
import { CreateItem } from "../../helpers/CRUD.js";
import {
  meter_types,
  heat_meter_kinds,
  installation_types,
} from "helpers/listsHardcodedData";
import { str2bool } from "../../helpers/utils.js";
import i18next from "i18next";

const ModalHeatMeterTypes = (props) => {
  const old_state = {
    nomEquipmentManufacturers: [],
    all_meter_types: [],
    all_installation_types: [],
  };

  const [state, setState] = useState({
    ...old_state,
    document: {
      name: "",
      equipmentManufacturerId: null,
      model: "",
      type: "",
      kind: "",
      range: "",
      installation: "",
      hasRadioModule: false,
    },
  });

  const getInitialState = (old_state) => ({
    ...old_state,
    document: {
      name: "",
      equipmentManufacturerId: null,
      model: "",
      type: "",
      kind: "",
      range: "",
      installation: "",
      hasRadioModule: false,
    },
  });

  const resetData = () => {
    setState(getInitialState(state));
  };

  const handleValidSubmit = (event, values) => {
    let patch = jsonpatch.compare(getInitialState().document, state.document);

    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/HeatMeterType/Add`;

    CreateItem(
      url,
      patch,
      (data) => {
        update();
        props.emitSuccess(i18next.t("entry_added_successfully"));
      },
      (error) => {
        props.emitErrors(error);
      }
    );
  };

  const toggleRadioModule = (e) => {
    const document = state.document;
    document.hasRadioModule = str2bool(e.target.value);

    setState((state) => ({ ...state, document }));
  };

  const closeModal = () => {
    props.closeModal();
    resetData();
  };

  const update = () => {
    props.update();
    resetData();
  };

  const getNomEquipmentManufacturers = () => {
    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/EquipmentManufacturer/GetAllByDeviceType?deviceType=Топломери`;

    sendRequest({
      url,
      method: "GET",
    })
      .then((resp) => resp.json())
      .then((data) => {
        const filtered = data.filter((item) =>
          item.type.includes("Топломери")
        );

        setState((state) => ({
          ...state,
          nomEquipmentManufacturers: filtered,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getNomEquipmentManufacturers();
  }, []);

  const installation_types_list = installation_types();
  const meter_types_list = meter_types();
  const heat_meter_kinds_list = heat_meter_kinds();

  state.all_meter_types = meter_types_list.filter((item) =>
    item.categories.includes("heat-meter-types")
  );

  state.all_installation_types = installation_types_list.filter((item) =>
    item.categories.includes("heat-meter-types")
  );

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Modal isOpen={props.isModalOpen} scrollable={true}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">
                {i18next.t("modal_heat_meter_type_title")}
              </h5>

              <button
                type="button"
                onClick={() => closeModal()}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <Card className="mb-0">
                <CardBody>
                  <AvForm
                    onValidSubmit={handleValidSubmit}
                    className="needs-validation"
                  >
                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="heat_meter_type_name">
                            {i18next.t("name")}
                          </Label>

                          <AvField
                            name="document.name"
                            placeholder={i18next.t("placeholder_enter_name")}
                            id="heat_meter_type_name"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  name: e.target.value,
                                },
                              }))
                            }
                            defaultValue={state.document.name}
                            className="w-100"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="heater_type_еquipment_manufacturer">
                            {i18next.t("manufacture")}
                          </Label>

                          <AvField
                            type="select"
                            name="document.equipmentManufacturerId"
                            id="heater_type_еquipment_manufacturer"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  equipmentManufacturerId: e.target.value,
                                },
                              }))
                            }
                            value={state.document.equipmentManufacturerId}
                            className="w-100"
                          >
                            <option
                              value=""
                              selected={
                                state.document.equipmentManufacturerId === ""
                                  ? true
                                  : false
                              }
                            >
                              {i18next.t("select_equipment_manufacturer")}
                            </option>
                            {state.nomEquipmentManufacturers &&
                              state.nomEquipmentManufacturers.length > 0 &&
                              state.nomEquipmentManufacturers.map(
                                (еquipmentManufacturer) => (
                                  <option
                                    key={`option-${еquipmentManufacturer.id}`}
                                    value={еquipmentManufacturer.id}
                                    selected={
                                      state.document.equipmentManufacturerId ===
                                      еquipmentManufacturer.id
                                        ? true
                                        : false
                                    }
                                  >
                                    {еquipmentManufacturer.name}
                                  </option>
                                )
                              )}
                          </AvField>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="heat_meter_type_model">
                            {i18next.t("model")}
                          </Label>

                          <AvField
                            name="document.model"
                            placeholder={i18next.t("placeholder_enter_model")}
                            id="heat_meter_type_model"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  model: e.target.value,
                                },
                              }))
                            }
                            defaultValue={state.document.model}
                            className="w-100"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="heat_meter_type_type">
                            {i18next.t("type")}
                          </Label>

                          <AvField
                            type="select"
                            name="document.type"
                            id="heat_meter_type_type"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  type: e.target.value,
                                },
                              }))
                            }
                            value={state.document.type}
                            className="w-100"
                          >
                            <option
                              value=""
                              selected={
                                state.document.type === "" ? true : false
                              }
                            >
                              {i18next.t("select_type")}
                            </option>
                            {state.all_meter_types &&
                              state.all_meter_types.length > 0 &&
                              state.all_meter_types.map((type) => (
                                <option
                                  key={type.key}
                                  value={type.key}
                                  selected={
                                    state.document.type === type.key
                                      ? true
                                      : false
                                  }
                                >
                                  {type.value}
                                </option>
                              ))}
                          </AvField>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="heat_meter_type_kind">
                            {i18next.t("kind")}
                          </Label>

                          <AvField
                            type="select"
                            name="document.kind"
                            id="heat_meter_type_kind"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  kind: e.target.value,
                                },
                              }))
                            }
                            value={state.document.kind}
                            className="w-100"
                          >
                            <option
                              value=""
                              selected={state.kind === "" ? true : false}
                            >
                              {i18next.t("select_kind")}
                            </option>
                            {heat_meter_kinds_list &&
                              heat_meter_kinds_list.length > 0 &&
                              heat_meter_kinds_list.map((kind) => (
                                <option
                                  key={kind.key}
                                  value={kind.key}
                                  selected={
                                    state.document.kind === kind.key
                                      ? true
                                      : false
                                  }
                                >
                                  {kind.value}
                                </option>
                              ))}
                          </AvField>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="heat_meter_type_range">
                            {i18next.t("range")}
                          </Label>

                          <AvField
                            name="document.range"
                            type="number"
                            step={0.1}
                            min={0}
                            placeholder={i18next.t("placeholder_enter_range")}
                            id="heat_meter_type_range"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  range: e.target.value,
                                },
                              }))
                            }
                            defaultValue={state.document.range}
                            className="w-100"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <FormGroup>
                          <Label htmlFor="heat_meter_type_installation">
                            {i18next.t("installation")}
                          </Label>

                          <AvField
                            type="select"
                            name="document.installation"
                            id="heat_meter_type_installation"
                            onChange={(e) =>
                              setState((state) => ({
                                ...state,
                                document: {
                                  ...state.document,
                                  installation: e.target.value,
                                },
                              }))
                            }
                            value={state.document.installation}
                            className="w-100"
                          >
                            <option
                              value=""
                              selected={
                                state.installation === "" ? true : false
                              }
                            >
                              {i18next.t("select_type")}
                            </option>
                            {state.all_installation_types &&
                              state.all_installation_types.length > 0 &&
                              state.all_installation_types.map(
                                (installationType) => (
                                  <option
                                    key={installationType.key}
                                    value={installationType.key}
                                    selected={
                                      state.document.installation ===
                                      installationType.key
                                        ? true
                                        : false
                                    }
                                  >
                                    {installationType.value}
                                  </option>
                                )
                              )}
                          </AvField>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col md="12">
                        <div className="form_controls">
                          <label>{i18next.t("radioModuleNumber")}</label>

                          <div>
                            <div className="radio">
                              <label>
                                <input
                                  type="radio"
                                  value="true"
                                  checked={
                                    state.document.hasRadioModule === true
                                  }
                                  onChange={(e) => toggleRadioModule(e)}
                                />
                                {i18next.t("yes")}
                              </label>
                            </div>

                            <div className="radio">
                              <label>
                                <input
                                  type="radio"
                                  value="false"
                                  checked={
                                    state.document.hasRadioModule === false
                                  }
                                  onChange={(e) => toggleRadioModule(e)}
                                />
                                {i18next.t("no")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => closeModal()}
                      >
                        <i className="fa fa-times mr-1" />
                        {i18next.t("button_cancel")}
                      </button>

                      <Button color="primary" type="submit">
                        <i className="fa fa-plus-circle mr-1" />
                        {i18next.t("button_add")}
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </div>
          </Modal>
        </Container>
      </div>
    </>
  );
};

ModalHeatMeterTypes.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  users: contacts.users,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUsers: () => dispatch(getUsers()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ModalHeatMeterTypes));
